export default __webpack_public_path__ + "static/media/tablePreview_1.52a970d6.png";